module.exports = __webpack_public_path__ + "img/Indonesia.8c2e8e8b.svg";